import { motion } from "framer-motion";
import { Reveal, SectionTag } from "./Reveal";

const STEPS = [
  "Attention",
  "Click",
  "Enquiry",
  "WhatsApp",
  "Qualification",
  "Consultation",
  "Booking",
];

export const FunnelVisual = () => {
  return (
    <section
      className="bg-charcoal py-24 md:py-32 relative overflow-hidden"
      data-testid="funnel-section"
    >
      <div className="absolute inset-0 geo-pattern-light opacity-[0.05]" />
      <div className="relative max-w-7xl mx-auto px-6">
        <Reveal>
          <SectionTag dark className="mb-10">
            {"The Acquisition Funnel"}
          </SectionTag>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-y-10 border-t border-cream/10 pt-10">
          {STEPS.map((step, i) => (
            <Reveal key={step} delay={i * 0.08}>
              <div className="pr-4" data-testid={`funnel-step-${i + 1}`}>
                <div className="text-xs font-semibold tracking-[0.25em] text-gold mb-3">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="text-cream text-lg md:text-xl font-semibold tracking-tight">
                  {step}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="origin-left h-px bg-gold/60 mt-10"
        />
        <Reveal delay={0.15}>
          <h2 className="mt-14 text-3xl md:text-5xl font-bold tracking-tighter text-cream max-w-3xl leading-[1.05]">
            {"Generating the lead is only one part of the job."}
          </h2>
          <p className="mt-6 text-cream/60 max-w-2xl text-base leading-relaxed">
            {"A click or a form fill does not fill a group departure. Nexus Catalyst builds the system around the lead (WhatsApp follow-up, qualification, consultation and retargeting) so attention has a real chance of becoming a booking opportunity."}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
